import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutes, AuthRoutes, AUTH_CLIENT_TOKEN, AuthClientProvider } from '@core';
import { map, Observable, take } from 'rxjs';

export const isAuthedGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authClient: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  const router: Router = inject(Router);

  return authClient.isAuthed$.pipe(
    take(1),
    map((authed: boolean): boolean | UrlTree =>
      authed ? true : router.parseUrl(`/${AppRoutes.AUTH}/${AuthRoutes.WELCOME}`)
    )
  );
};
